<template>
  <div class="comics-items">
    <div
      v-for="item in items"
      :key="`items-item-${item.id}`"
      :class="{ active: comicsInfo && comicsInfo.id === item.id }"
      class="comics-item"
    >
      <div @click="getInfo(item.id)" class="poster">
        <img :data-src="item.poster" :alt="item.title" src="/static_files/no-poster.png" class="lazyload">
        <!-- <img :data-src="item.poster" :alt="item.title" src="/static_files/no-poster.png" class="lazy"> -->
      </div>
      <nuxt-link :to="`/comics/${postUrl(item.id, item.title)}`">{{ item.title | filterTitle }}</nuxt-link>
    </div>

    <transition name="toLeft">
      <div v-if="comicsInfo" class="comics-info">
        <div class="menu">
          <div @click="menuCurrent = 'about'" :class="{ active: menuCurrent === 'about' }" class="item">
            Описание
          </div>
          <div @click="menuCurrent = 'chapters'" :class="{ active: menuCurrent === 'chapters' }" class="item">
            Главы <span v-if="comicsInfo.parts.length">{{ comicsInfo.parts.length }}</span>
          </div>
          <i @click="comicsInfo = null" class="close" />
        </div>
        <div class="header">
          <div class="top">
            <div class="poster">
              <img :src="comicsInfo.poster" alt="">
            </div>
            <div class="title">
              <nuxt-link :to="`/comics/${postUrl(comicsInfo.id, comicsInfo.title)}`">{{ comicsInfo.title }}</nuxt-link>
              <div>
                <span>{{ comicsInfo.category }} &middot;</span>
                <span>{{ comicsInfo.year }} &middot;</span>
                <span>{{ comicsInfo.status }}</span>
              </div>
              <div class="footer">
                <template v-if="comicsInfo.stats">
                  <span v-if="comicsInfo.stats.rating.length">
                    <img src="/static_files/icons/star-gold.svg" alt="">
                    {{ comicsInfo.stats.rating | filterRating }}
                  </span>
                  <span v-if="comicsInfo.stats.likes.length">
                    <img v-if="user" :src="`/static_files/icons/heart${comicsInfo.stats.likes.includes(user.id) ? '-active' : ''}.svg`" alt="">
                    <img v-else src="/static_files/icons/heart-dark.svg" alt="">
                    {{ comicsInfo.stats.likes.length }}
                  </span>
                </template>
                <div style="width:240px;">
                  <Fav :fav="comicsInfo" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="menuCurrent === 'about'">
          <div class="body">
            <div v-if="comicsInfo.desc" class="description">
              {{ comicsInfo.desc }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="body">
            <div class="parts">
              <nuxt-link
                v-for="(p, index) in comicsInfo.parts"
                :to="`/comics/${comicsInfo.id}/chapter/${index}`"
                :key="`info-part-${p}`"
                tag="div"
                class="item"
              >
                {{ p.title }}
              </nuxt-link>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    Fav: () => import('~/components/Fav.vue')
  },
  filters: {
    filterRating(val) {
      if (!val.length) return 0
      let sum = 0
      val.forEach(el => {
        sum += el.rating
      })
      return sum / val.length
    },
    filterTitle(val) {
      const findSlash = val.split(' / ')
      if (findSlash.length > 1) {
        return findSlash[1]
      } else {
        return val
      }
    },
    // filterTitle(val) {
    //   const findEn = val.match(/^[a-z].*/gi)
    //   if (findEn) {
    //     let title = ''
    //     title = val.slice(val.indexOf('/') + 1)
    //     title = title.slice(0, title.indexOf('/'))
    //     return title
    //   }
    //   return val
    // },
  },
  props: { items: { type: Array, required: true, default: () => [] } },
  watch: {
    comicsInfo(val) {
      this.menuCurrent = 'about'
      if (!this.isDesktop) {
        if (val) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      }
    }
  },
  computed: mapState(['user', 'isDesktop']),
  data() {
    return {
      comicsInfo: null,
      menuCurrent: 'about',
    }
  },
  mounted() {
    window.addEventListener('keyup', this.switchFavs)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.switchFavs)
  },
  methods: {
    switchFavs(event) {
      if (event.keyCode === 27) {
        this.comicsInfo = null
      }
    },
    async getInfo(id) {
      if (this.comicsInfo && this.comicsInfo.id === id) return
      const { data } = await this.$axios.get(`/api/comics/${id}/info`)
      this.comicsInfo = data
    }
  }
}
</script>

<style src="~/assets/items.styl" lang="stylus" />
